// *******************************************************
// Dimensions.js
// -------------------------------------------------------
// All page locations throughout the application
// -------------------------------------------
export const SVG_VIEW_WIDTH = 2048;
export const SVG_VIEW_HEIGHT = 1536;
// export const APP_WIDTH = RAW_APP_WIDTH / 2;
// export const APP_HEIGHT = RAW_APP_HEIGHT / 2;
// export const APP_WIDTH = "100%";
/* eslint-disable */
export const APP_WIDTH = window.innerWidth;
export const APP_HEIGHT = window.innerHeight;
/* eslint-enable */
// -------------------------------------------



// WEBPACK FOOTER //
// ./src/constants/dimensions.js